<template>
  <div class="expired-token-container">
    <img src="@/assets/connection-refuse.svg" />
    <div class="connect-title">Connect to Notifi!</div>
    <div class="connect-subtitle">
      It's been a while! Connect to Notifi to load your <br />notification
      details.
    </div>
    <p-button
      class="p-button-primary notifi-reconnect-button"
      @click="handleClick"
    >
      Connect to Notifi
    </p-button>
  </div>
</template>

<script lang="ts" setup>
import { useNotifiStore } from '@/notifi-vue-package/stores';
import { NotifiFrontendClient } from '@notifi-network/notifi-frontend-client';
type IProps = {
  signMessageParams: Parameters<NotifiFrontendClient['logIn']>[0];
};

const props = defineProps<IProps>();
const notifiStore = useNotifiStore();

const { notifiClient, setNotifiClient } = notifiStore;

const handleClick = async () => {
  if (notifiClient === null) {
    return;
  }
  await notifiClient.logIn(props.signMessageParams);

  await setNotifiClient(notifiClient);
};
</script>

<style lang="css" scoped>
.expired-token-container {
  height: 492px;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
  text-align: center;
  align-items: center;
  row-gap: 12px;
}

.connect-title {
  margin-top: 25px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.0043em;
  font-weight: 600;
}

.connect-subtitle {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 17px;
  opacity: 0.5;
  line-height: 22px;
  letter-spacing: -0.0043em;
  font-weight: 400;
}

.notifi-reconnect-button {
  display: flex;
  justify-content: center;
  width: 272px;
  text-align: center;
}
</style>
